import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type { GetDashboardArgs } from './types/args';
import type { GetDashboardsResult } from './types/results';

export class DashboardsApiClient extends BaseApiClient {
  constructor() {
    super('api/dashboard');
  }

  public async get(filter: GetDashboardArgs, signal: RequestOptions['signal']): Promise<GetDashboardsResult> {
    return await this.http.get('', { query: getQuery({ ...filter }), signal });
  }
}
